<template>

  <t-page>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 msg-return-gender-feminine
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage">

      <template #search>

        <b-button-group class="mr-3">

          <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                    :to="currentPage.name + '-form-new'" primary/>

          <t-dropdown variant="outline-primary" icon-settings
                      :items-relation-pages="userAuth.relationPages"/>

        </b-button-group>


        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         placeholder="Ordem de Fabricação"
                                         big-search
                                         :fields-custom="entityFieldCustomized('page')"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form">

          <slot name="search-header"></slot>

          <slot name="search-default"></slot>

          <b-row>

            <b-col cols="6">
              <t-input-search v-model="form.issueDate" enable-range date label="Data de Emissão"/>

            </b-col>

            <b-col cols="3">

              <t-input-search v-model="form.hasStock" :options="yesOrNotOptions" label="Está no estoque?" boolean/>

            </b-col>

            <b-col cols="3">
              <t-input-search label="Nº Expedição" number v-model="form.expeditionNumber"/>
            </b-col>

          </b-row>

          <b-row>


            <b-col cols="4">

              <t-input-product v-model="form.productId"/>

            </b-col>

            <b-col cols="4">

              <t-input-code-label disable-name lot v-model="form.lotId"/>

            </b-col>

            <b-col cols="4">

              <t-input-search v-model="form.reprocessed" :options="yesOrNotOptions" label="Reprocessado?" boolean/>

            </b-col>

          </b-row>

          <b-row>

            <t-input-search v-model="form.groupProductId"
                            :options="groupProductOptions"
                            label="Grupo de Produto"
                            cols="4"
                            select/>


            <t-input-search cols="4" v-model="form.model" label="Modelo"/>


            <b-col cols="4">

              <t-input-code-label material v-model="form.materialId"/>

            </b-col>


          </b-row>


          <b-row>

            <t-input-search cols="4" v-model="form.stepCurrentProcessFlowStepId" :options="stepOptions"
                            label="Etapa atual (ordens em andamento)"
                            help="Ordens de Fabricação que estão em andamento poderão ser filtradas por etapa." select
                            placeholder="Todas"/>

            <t-input-search v-model="form.operationStatusId" cols="4" select
                            :options="typeStatusProductionOptions"
                            label="Status Operacional"/>

            <t-input-search v-model="form.statusBatch" cols="4" select :options="StatusProductionOrderType.list"
                            label="Status Geral"/>


          </b-row>

          <b-row>

            <b-col cols="6">

              <t-input-search v-model="form.typeNonConformanceId" select
                              :options="typeNonConformanceOptions" help="Válido para material off-spec"
                              label="Tipo Não Conformidade"/>


            </b-col>

            <b-col cols="6">

              <t-input-search v-model="form.typeRestrictionId" select
                              :options="typeRestrictionOptions" help="Válido para material convencional"
                              label="Tipo Restrição"/>

            </b-col>

          </b-row>




          <slot name="search-footer"></slot>


          <!--          <t-input-search v-if="getRenderRule('productionMultiBatch')" v-model="searchForm.operationStatusId" select
                                    :options="typeStatusProductionOptions"
                                    label="Status Operacional"/>-->


        </t-content-header-search-default>

      </template>

      <t-table :show="checkViewListTableDefault()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="userAuth.viewFields"
               link-primary-column="productionOrderCodeLabel"
               primary-key-column="productionOrderNumber">


        <!-- TEMPLATES QUE NÃO FORAM ESPECIFICADOS E PODEM SER UTILIZADOS, INCLUINDO CAMPOS CUSTOMIZADOS 'item(field_000)' -->
        <template v-for="field in getViewFields(itemSlotsDefault)" v-slot:[mountTemplate(field)]="{item}">
          <slot :name="'item(' + field.key + ')'" :item="item">
            <t-table-field :column="field.key" :formatter="field.formatter" :item="item"/>
          </slot>
        </template>

        <!-- TEMPLATES PRÉ-DETERMINADOS COM FORMATAÇÃO, PORÉM PODERÃO SER SOBREPOSTOS TAMBÉM-->
        <template #item(statusProduction)="{item}">
          <slot name="item(statusProduction)" :item="item">
            <div class="d-flex align-items-center"
                 v-if="item.statusOrder === StatusProductionOrderType.type.PRODUCTION || item.statusOrder === StatusProductionOrderType.type.REPROVED">
              <span v-if="item.statusProductionColor !== ''" class="badge badge-dot badge-dot-xl mr-2"
                    :style="{'background-color': item.statusProductionColor}"></span> {{ item.statusProduction }}
            </div>
            <span v-else></span>
          </slot>
        </template>

        <template #item(hasStock)="{item}">
          <slot name="item(hasStock)" :item="item">
            <span
                v-if="item.statusBatch === StatusProductionOrderType.type.DONE ||  item.statusBatch === StatusProductionOrderType.type.REPROVED">{{
                item.hasStock | yesOrNot
              }}</span>
            <span v-else>-</span>
          </slot>
        </template>

        <template #item(expeditionNumber)="{item}">
          <slot name="item(expeditionNumber)" :item="item">
            <b-link target="_blank" v-if="objValid(item.expeditionNumber) && item.expeditionNumber > 0" :to="'/stock/expedition-order/'+item.expeditionNumber">{{ item.expeditionNumber }}
            </b-link>
            <span v-else>-</span>
          </slot>
        </template>

        <template #item(reprocessedDate)="{item}">
          <slot name="item(reprocessedDate)" :item="item">

            <b-badge v-if="objValid(item.reprocessedDate)" variant="focus">REPROCESSADO</b-badge>
            <div v-else-if="item.reprocessedParentProductionOrderId > 0">Origem:
              <b-link target="_blank" :to="'/custom/production/order/'+item.reprocessedParentProductionOrderNumber">
                {{ item.reprocessedParentProductionOrderCodeLabel }}
              </b-link>
            </div>

          </slot>
        </template>

        <template #item(statusOrder)="{item}">

          <slot name="item(statusOrder)" :item="item">
            <ProductionStatusBadge :status="item.statusOrder"/>
          </slot>
        </template>

        <template #append-actions="{item}">
          <slot name="append-actions" :item="item">
            <b-button
                v-if="item.pdfReportId && item.pdfReportId > 0"
                v-b-tooltip.hover.ds500 title="Gerar PDF"
                @click="downloadReport(item.pdfReportId, item.productionOrderId, item.productionOrderCodeLabel)"
                size="sm" variant="outline">
              <b-icon-file-pdf variant="primary"></b-icon-file-pdf>
            </b-button>
          </slot>
        </template>
        <!-- FIM DOS TEMPLATES PADRÕES -->

      </t-table>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import StatusProductionOrderType from "@/model/types/modules/production/StatusProductionOrderType";
import TypeStatusProductionService from "@/services/modules/production/TypeStatusProduction.service";
import ProductionStatusBadge from "@/views/modules/production/ProductionOrder/components/ProductionStatusBadge"
import pageListEmbeddableMixin from "@/mixins/page/pageListEmbeddableMixin";
import ProcessFlowStepService from "@/services/modules/production/ProcessFlowStep.service";
import groupProductService from "@/services/modules/product/GroupProduct.service";
import TypeNonConformanceService from "@/services/modules/production/TypeNonConformance.service";
import TypeRestrictionService from "@/services/modules/production/TypeRestriction.service";

export default {
  components: {ProductionStatusBadge},
  mixins: [pageDefaultMixin, pageListMixin, pageListEmbeddableMixin],
  name: 'ProductionOrderEmbeddable',
  data() {
    return {
      itemSlotsDefault: ["statusBatch", "statusProduction"],  /*Listagem de nomes de slotes que já foram declarados no padrão #item(X)*/
      StatusProductionOrderType,
      path: "production/order", //Utilizar somente quando fora do padrão
      enableGeneralFields: true,
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      stepOptions: [],
      groupProductOptions: [],
      typeStatusProductionOptions: [],
      typeNonConformanceOptions: [],
      typeRestrictionOptions: [],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {


    mountedPrepare() {

      this.mountedPrepareEmbeddable()

      //Remove status padrão da busca


    },
    async mountedContinued() {

      this.pageListIsLoaded = false

      await TypeStatusProductionService.selectList("")
          .then(list => this.typeStatusProductionOptions = list)
          .catch(error => this.responseError(error))

      await TypeNonConformanceService.selectList().then((response) => {
        this.typeNonConformanceOptions = response
      }).catch(error => this.responseError(error))

      await TypeRestrictionService.selectList().then((response) => {
        this.typeRestrictionOptions = response
      }).catch(error => this.responseError(error))

      await ProcessFlowStepService.selectList(this.form.processFlowId, true)
          .then(list => this.stepOptions = list)
          .catch(error => this.responseError(error))


      await groupProductService.selectList().then((list) => {
        this.groupProductOptions = list
      }).catch(error => this.responseError(error))


      this.pageListIsLoaded = true

      await this.mountedContinuedEmbeddable() //Sempre no final

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()


  },
}
</script>
